import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';


const authConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: environment.cognito.oauth.domain,
          scopes: environment.cognito.oauth.scope,
          redirectSignIn: [environment.cognito.oauth.redirectSignIn],
          redirectSignOut: [environment.cognito.oauth.redirectSignOut],
          responseType: environment.cognito.oauth.responseType as 'code'
        }
      }
    }
  }
} as any;

Amplify.configure(authConfig)

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
